module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Overview Report")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filterUsers,
      "item-value": "id",
      "item-text": "name",
      "label": "Filter",
      "solo": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%",
      "color": "rgba(0,0,0,0.12)",
      "margin-top": "0px"
    }
  })], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.overviewHeaders,
      "items": _vm.overviewData,
      "single-expand": "",
      "expanded": _vm.expanded,
      "show-expand": ""
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [(item.type === 'group') ? _c('v-icon', [_vm._v("mdi-domain")]) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n                ")]
      }
    }, {
      key: "item.totalIOAmount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "primary",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalIOAmount)))])], 1)]
      }
    }, {
      key: "item.totalRevenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "green",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalRevenue)))])], 1)]
      }
    }, {
      key: "item.totalCompletion",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          style: ({
            color: _vm.getColor(item.totalCompletion)
          })
        }, [_vm._v(_vm._s(item.totalCompletion) + " %")])]
      }
    }, {
      key: "item.totalPayout",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-icon', {
          staticClass: "currency",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalPayout)) + "\n                ")]
      }
    }, {
      key: "item.lastIODate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.lastIODate)) + " ")])]
      }
    }, {
      key: "item.CO",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.CO), function(obj, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-1",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                        " + _vm._s(obj.firstName) + "\n                    ")])
        })
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.campaigns) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "elevation-1",
          attrs: {
            "headers": _vm.detailsHeaders,
            "items": item.campaigns,
            "hide-default-footer": ""
          },
          scopedSlots: _vm._u([{
            key: "item.IOAmount",
            fn: function(ref) {
              var item = ref.item;

              return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "primary",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
            }
          }, {
            key: "item.budget",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n                      ")]
            }
          }, {
            key: "item.payout",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.payout)) + "\n                      ")]
            }
          }, {
            key: "item.revenvue",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "green",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenvue)))])], 1)]
            }
          }, {
            key: "item.completion",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                style: ({
                  color: _vm.getColor(item.completion)
                })
              }, [_vm._v(_vm._s(item.completion))])]
            }
          }, {
            key: "item.dateAt",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.dateAt)) + " ")])]
            }
          }, {
            key: "item.AM",
            fn: function(ref) {
              var item = ref.item;

              return _vm._l((item.AM), function(obj, index) {
                return _c('v-chip', {
                  key: index,
                  staticClass: "ma-1",
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                            " + _vm._s(obj.firstName) + "\n                        ")])
              })
            }
          }], null, true)
        })], 1) : _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          key: _vm.dataTableKey,
          staticClass: "elevation-1",
          attrs: {
            "headers": _vm.overviewHeaders,
            "items": item.clients,
            "single-expand": "",
            "expanded": _vm.expanded2,
            "show-expand": ""
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded2 = $event
            }
          },
          scopedSlots: _vm._u([{
            key: "item.totalIOAmount",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "primary",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalIOAmount)))])], 1)]
            }
          }, {
            key: "item.totalRevenue",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "green",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalRevenue)))])], 1)]
            }
          }, {
            key: "item.totalCompletion",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                style: ({
                  color: _vm.getColor(item.totalCompletion)
                })
              }, [_vm._v(_vm._s(item.totalCompletion) + " %")])]
            }
          }, {
            key: "item.totalPayout",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalPayout)) + "\n                        ")]
            }
          }, {
            key: "item.lastIODate",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.lastIODate)) + " ")])]
            }
          }, {
            key: "item.CO",
            fn: function(ref) {
              var item = ref.item;

              return _vm._l((item.CO), function(obj, index) {
                return _c('v-chip', {
                  key: index,
                  staticClass: "ma-1",
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                                " + _vm._s(obj.firstName) + "\n                            ")])
              })
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [_c('td', {
                staticStyle: {
                  "border": "none",
                  "padding": "20px"
                },
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-data-table', {
                staticClass: "elevation-1",
                attrs: {
                  "headers": _vm.detailsHeaders,
                  "items": item.campaigns,
                  "hide-default-footer": ""
                },
                scopedSlots: _vm._u([{
                  key: "item.IOAmount",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
                      staticClass: "ma-1",
                      attrs: {
                        "color": "primary",
                        "small": "",
                        "text-color": "white"
                      }
                    }, [_c('v-icon', {
                      staticClass: "mr-0",
                      attrs: {
                        "small": "",
                        "left": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
                  }
                }, {
                  key: "item.budget",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-icon', {
                      staticClass: "currency",
                      attrs: {
                        "small": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n                                  ")]
                  }
                }, {
                  key: "item.payout",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-icon', {
                      staticClass: "currency",
                      attrs: {
                        "small": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.payout)) + "\n                                  ")]
                  }
                }, {
                  key: "item.revenvue",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-chip', {
                      staticClass: "ma-1",
                      attrs: {
                        "color": "green",
                        "small": "",
                        "text-color": "white"
                      }
                    }, [_c('v-icon', {
                      staticClass: "mr-0",
                      attrs: {
                        "small": "",
                        "left": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenvue)))])], 1)]
                  }
                }, {
                  key: "item.completion",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('div', {
                      style: ({
                        color: _vm.getColor(item.completion)
                      })
                    }, [_vm._v(_vm._s(item.completion))])]
                  }
                }, {
                  key: "item.dateAt",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.dateAt)) + " ")])]
                  }
                }, {
                  key: "item.AM",
                  fn: function(ref) {
                    var item = ref.item;

                    return _vm._l((item.AM), function(obj, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-1",
                        attrs: {
                          "small": ""
                        }
                      }, [_vm._v("\n                                        " + _vm._s(obj.firstName) + "\n                                    ")])
                    })
                  }
                }], null, true)
              })], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6bab890"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/summaryOfAccount.vue
// module id = 2274
// module chunks = 0